import { ShopperMissionSocialPage } from "./../shopper-mission-social/shopper-mission-social";
import { ShopperHomePage } from "./../shopper-home/shopper-home";
// import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-social-group-join-scan-confirm",
  templateUrl: "shopper-social-group-join-scan-confirm.html",
})
export class ShopperSocialGroupJoinScanConfirmPage {
  mission_member_no = 0;
  your_mission_name = "";
  leader_mission_name = "-";
  mission_text = "";
  social_group = "";
  theme = 1;
  mission_group: "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    // private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.mission_group = this.navParams.data.mission_group;
    this.social_group = this.navParams.data.social_group;
    this.your_mission_name = this.navParams.data.mission_text;
    this.mission_member_no = this.navParams.data.result.member_social;
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      if (this.social_group != "0") {
        var link = this.services.URLShopperMissions + "/" + this.social_group;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe((data) => {
            this.storage.get("language").then((lang) => {
              if (lang == "th-TH") {
                this.leader_mission_name = data.mission_text_th;
              } else {
                this.leader_mission_name = data.mission_text_en;
              }
              loader.dismiss();
            });
          });
      }
    });
  }

  confirm() {
    this.navCtrl.push(ShopperMissionSocialPage);
    // const loader = this.loadingCtrl.create({
    //   content: "Loading...",
    // });
    // loader.present();
    // this.storage.get("token").then((token) => {
    //   let body =
    //     "mission_no=" +
    //     this.result.mission_no +
    //     "&user_id=" +
    //     this.result.user_id +
    //     "&member_mission_no=" +
    //     this.mission_no;
    //   console.log("body=", body);
    //   var link =
    //     this.services.URLShopperMissions +
    //     "/" +
    //     this.result.mission_no +
    //     "/members";
    //   var headers = new Headers();
    //   headers.append("Content-Type", "application/x-www-form-urlencoded");
    //   headers.append("Accept", "application/json");
    //   headers.append("Authorization", "Bearer " + token);
    //   const requestOptions = new RequestOptions({ headers: headers });
    //   this.http
    //     .post(link, body, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         loader.dismiss();
    //         this.navCtrl.push(ShopperMissionSocialPage);
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);
    //         loader.dismiss();
    //         this.translateService.get(response.message).subscribe((value) => {
    //           this.services.presentToast(value);
    //         });
    //       }
    //     );
    // });
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-join-scan-confirm/shopper-social-group-join-scan-confirm.ts